import { CustomTreeFilterComponent } from "./component";
import { doesFilterPass } from "./handler";

const CustomTreeFilter = {
  component: CustomTreeFilterComponent,
  doesFilterPass
};

export default CustomTreeFilter;
